import React, {Fragment, useState} from 'react'
import {Field, ErrorMessage} from 'formik'
import AutocompleteForm from './AutocompleteForm';
import AutocompleteTextForm from './AutocompleteTextForm';
import SelectMultipleForm from './SelectMultipleForm';


import { useDispatch } from 'react-redux';


function CustomInput(props: {element: string, formikProps: any, delta?: number, form_name: string, state_modal?: any}){
    const element = window.FormSettings[props.form_name][props.element]
    //console.log("formikProps", props.formikProps.values)

    let isVisible = true
    if(typeof element?.states !== undefined && element?.states){
	   
	    var i = 0
        //CHECK ALL #STATES (ccategorie, checkbox...)
        Object.values(element.states).forEach((state: any)=>{
            var target_field_value = Number(props.formikProps.values[Object.keys(element.states)[i]])
            var condition_target_field_value : any = Object.values(element.states)[i]

           // console.log(element.name, target_field_value, condition_target_field_value, condition_target_field_value.includes(target_field_value));
            if(!condition_target_field_value.includes(target_field_value)){
	            isVisible = false
            }
            
         //   console.log(i, Object.keys(element.states), Object.keys(element.states)[i], "STATE", target_field_value, condition_target_field_value, state, isVisible)
            
            i++
            
        })

	    
	    /*
        var target_field_value = Number(props.formikProps.values[Object.keys(element.states)[0]])
        var condition_target_field_value : any = Object.values(element.states)[0]
        //console.log('T =>', target_field_value, 'C =>', condition_target_field_value, 'R =>',condition_target_field_value.includes(target_field_value))
        if(condition_target_field_value.includes(target_field_value)){
            isVisible = true
        }
        else{
            return null
        }
        */
        
    }
    else{
        isVisible = true
    }
    let isRequired = false
    if(typeof element?.states_required !== undefined && element?.states_required){
        var i = 0
        Object.values(element.states_required).forEach((state: any)=>{

            var target_field_value = Number(props.formikProps.values[Object.keys(element.states_required)[i]])
            var condition_target_field_value : any = Object.values(element.states_required)[i]
            if(condition_target_field_value.includes(target_field_value)){
                isRequired = true
            }
            i++
        })
        
        element.required = isRequired
       
    }
    if(element.states_force){
        var j = 0;
        Object.values(element.states_force).forEach((state: any)=>{
            var target_field_value = Number(props.formikProps.values[Object.keys(element.states_force)[j]])
            var condition_target_field_value : any = Object.values(element.states_force)[j]
            if(condition_target_field_value.includes(target_field_value)){
                isVisible = true
            }
        })
    }
    if(element.states_nastyfix){
        var k = 0;
        Object.values(element.states_nastyfix).forEach((state: any)=>{
            var target_field_value = Number(props.formikProps.values[Object.keys(element.states_nastyfix)[k]])
            var condition_target_field_value : any = Object.values(element.states_nastyfix)[k]
            if(condition_target_field_value.includes(target_field_value)){
                isRequired = false
            }
        })
        element.required = isRequired
    }
    
    //SET VISIBLE
    window.FormSettings[props.form_name][props.element]["visible"] = isVisible
    element.visible = isVisible
    
    if(element?.title && element?.type && isVisible){
        return(
            <SwitchInput type={element.type? element.type.toString() : ""} element={element} formikProps={props.formikProps} delta={props.delta} form_name={props.form_name} state_modal={props.state_modal} is_required={isRequired}  visible={isVisible}/>
        )
    }
    return null
}

function SwitchInput(props: {type: string, element: any, formikProps: any, delta?: number, form_name: string, state_modal?: any, is_required?: boolean, visible?: boolean}){

	const [deltaFile, setDeltaFile] = useState(0)
	
	const dispatch = useDispatch();

    const element = props.element
    var controlledType = element.type? element.type.toString() : "text"
    var nameInput = element.name ? element.name.toString() : ""
    
    const stateModal = props.state_modal

//    console.log("MODAL props", nameInput, props.is_required, props.formikProps)
    if(element.name == 'field_domain' && element.default_value){
    }
    if(element.name && element.parent_name){
        nameInput = element.parent_name +'.'+props.delta+'.'+ element.child_name
        //element.name = nameInput
        
        //window.FormSettings[props.form_name][nameInput] = element
        
       // console.log("nameInput", nameInput, element)
    }
    switch(props.type) {
	    	case 'markup':
                return (
					<div className='col-lg-12'>
                        <div className='fv-row mb-5'  dangerouslySetInnerHTML={{__html: element.markup}}>

						</div>
                    </div>
				)
            case 'select':
            	if(element.multiple){
	            	return (
	                    <div className='col-lg-12'>
	                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
		                        <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                                <div className="w-100">
                                    <Field
                                        type="select"
                                        className='form-control form-control-lg form-control-solid'
                                        name={nameInput}
                                        component={SelectMultipleForm}
                                        form_name={props.form_name}
                                        id={element.id ? element.id.toString() : ""}
                                        element={element}
                                        formikProps={props.formikProps}
                                        multiple
                                    />
                                    <div className='text-danger mt-2'>
                                        <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                    </div>
                                    {element.description ? (
                                        <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                    ):null}
                                </div>
		                    </div>
	                    </div>
	                )
            	}else{
	                return (

	                    <div className='col-lg-12'>
	                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                                <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                                <div className="w-100">
                                    <Field
                                        as={controlledType}
                                        className='form-control form-control-lg form-control-solid'
                                        name={nameInput}
                                        id={element.id ? element.id.toString() : ""}
                                        disabled={props.element.disabled ? true : false}
                                    >
                                        <option value=''>- Select -</option>
                                        {element.options.map((opt:any, i:any)=>(
                                            <Fragment key={i}>
                                                {opt.value !== '_none' ?(
                                                    <option key={i} value={opt.value}>{[opt.label]}</option>
                                                ):null }
                                            </Fragment>
                                        ))}
                                    </Field>
                                    <div className='text-danger mt-2'>
                                        <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                    </div>
                                    {element.description ? (
                                        <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                    ):null}
                                </div>
		                    </div>
	                    </div>
					)
				}
            case 'radio':
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                        <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                        <div className="w-100">
                            <div role="group" className='d-flex' aria-labelledby={element.id ? element.id.toString() : ""}>
                                {Object.entries(element.options).map((opt, i)=>(
                                    <Fragment key={i}>
                                        {opt[0] !== '_none' ?(
                                            <label className='form-check-label me-4'>
                                                <Field
                                                    className='form-check-input me-2'
                                                    type='radio'
                                                    name={nameInput}
                                                    value={opt[0]}
                                                    /* checked={element.value == opt[0]}
                                                     onChange={() => props.formikProps.values[nameInput] = opt[0]} */
                                                />
                                                {opt[1]}
                                            </label>
                                        ):null }
                                    </Fragment>
                                ))}
                            </div>
                            <div className='text-danger mt-2'>
                                <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                            </div>
                            {element.description ? (
                                <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                            ):null}
                        </div>
                    </div>
                    </div>
            )
            case 'textarea':
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                        <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                        <div className="w-100">
                            <Field
                                as={controlledType}
                                className='form-control form-control-lg form-control-solid'
                                name={nameInput}
                                rows="1"
                                id={element.id ? element.id.toString() : ""}
                            />
                            <div className='text-danger mt-2'>
                                <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                            </div>
                            {element.description ? (
                                <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                            ):null}
                        </div>
                    </div>
                    </div>
                )
            case 'datetime':
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                        <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                        <div className="w-100">
                            <Field
                                type='date'
                                className='form-control form-control-lg form-control-solid'
                                name={nameInput}
                                id={element.id ? element.id.toString() : ""}
                            />
                            <div className='text-danger mt-2'>
                                <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                            </div>
                            {element.description ? (
                                <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                            ):null}
                        </div>
                    </div>
                    </div>
                )
            case 'managed_file':
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                            <div className="w-100">
                                <Field
                                    type="file"
                                    className='form-control form-control-lg form-control-solid'
                                    name={nameInput +'control'}
                                    id={element.id ? element.id.toString() : ""}
                                    multiple={element.multiple}
                                    accept={element.accept ? element.accept.toString() : ""}
                                    onChange={(event: any) =>{
                                        props.formikProps.setFieldValue(nameInput, event.target.files);
                                    }}
                                >

                                </Field>
                                <div className="d-flex">

                                    {Object.values(element.default_value_data).map((uploadFile : any, index: number)=>(
                                        <Fragment key={index}>
                                            {typeof uploadFile != "undefined" ? (
                                                <div key={index} className="border border-radius-5 p-3 w-auto">
                                                    {console.log()}
                                                    {uploadFile.url && uploadFile.url.split('.').pop() != 'pdf' ?
                                                        <img className="h-auto img-fluid me-2" width="35" src={uploadFile.url} alt='profil-pic' /> : ""
                                                    }
                                                    {uploadFile.name &&  uploadFile.url.split('.').pop() === 'pdf' ? <a href={uploadFile.url} target='_blank'> {uploadFile.name} </a>: uploadFile.name}
                                                    <button type="button" className='mx-3 btn-close' onClick={()=>{
                                                        element.default_value_data[index] = undefined

                                                        setDeltaFile(deltaFile - 1);
                                                    }}></button>

                                                </div>
                                            ) : null}
                                        </Fragment>
                                    ))}

                                    {Object.values(props.formikProps.values[nameInput]).map((uploadFile : any, index: number)=>(
                                        <Fragment key={index}>
                                            {typeof uploadFile != "undefined" ? (
                                                <div key={index} className="border border-radius-5 p-3 w-auto">
                                                    {uploadFile.name ? uploadFile.name : uploadFile}
                                                    <button type="button" className='mx-3 btn-close' onClick={()=>{
                                                        // console.log("props.formikProps.values", props.formikProps.values, props.formikProps.values[nameInput] )
                                                        if(typeof props.formikProps.values[nameInput] != "undefined"){
                                                            //props.formikProps.values[nameInput] = undefined
                                                            setDeltaFile(deltaFile - 1);
                                                            //props.formikProps.setFieldValue(nameInput,props.formikProps.values[nameInput] )
                                                        }
                                                    }}></button>

                                                </div>
                                            ) : null}
                                        </Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            case "entity_autocomplete":
            	return (
                    <div className='col-lg-12 autocomplete'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
	                        <div className="w-100">
                                <Field
                                    type="select"
                                    className='form-control form-control-lg form-control-solid'
                                    name={nameInput}
                                    component={AutocompleteForm}
                                    form_name={props.form_name}
                                    onChange={props.formikProps.handleChange(nameInput)}
                                    id={element.id ? element.id.toString() : ""}
                                    element={element}
                                    formikProps={props.formikProps}
                                    multiple
                                />
                                {typeof element.add_new != "undefined" ? (
                                    <>
                                        <a
                                            href={'#' + element.add_new.id}
                                            onClick={(event)=>{
                                                //console.log("MODAL", props, stateModal)
                                                stateModal(true)
                                            }}
                                        >
                                            {element.add_new.label}
                                        </a>
                                    </>
                                ):(
                                    <></>
                                )}

                                <div className='text-danger mt-2'>
                                    <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                </div>

                                {element.description ? (
                                    <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                ):null}
                            </div>
	                    </div>
                    </div>
                )
            case "autocomplete_text":
            	return (
                    <div className='col-lg-12 autocomplete'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
	                        <div className="w-100">
                                <Field
                                    type="select"
                                    className='form-control form-control-lg form-control-solid'
                                    name={nameInput}
                                    component={AutocompleteTextForm}
                                    form_name={props.form_name}
                                    id={element.id ? element.id.toString() : ""}
                                    element={element}
                                    formikProps={props.formikProps}
                                    multiple
                                />

                                <div className='text-danger mt-2'>
                                    <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                </div>

                                {element.description ? (
                                    <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                ):null}
                            </div>
	                    </div>
                    </div>
                )
            case "hidden":
                return (
                    <Field
                        type="hidden"
                        className='form-control form-control-lg form-control-solid'
                        name={nameInput}
                        id={element.id ? element.id.toString() : ""}
                    />
                )
            case "url":
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
	                        <div className="w-100">
                                <Field
                                    type={controlledType}
                                    className='form-control form-control-lg form-control-solid'
                                    name={nameInput}
                                    id={element.id ? element.id.toString() : ""}
                                />
                                <div className='text-danger mt-2'>
                                    <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                </div>
                                {element.description ? (
                                    <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                ):null}
                            </div>
	                    </div>
                    </div>
                )
            case "checkbox":
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-center justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
                            <div className="w-100 form-check">
                                <Field
                                    type={controlledType}
                                    className='form-check-input'
                                    name={nameInput}
                                    id={element.id ? element.id.toString() : ""}
                                />
                                <div className='text-danger mt-2'>
                                    <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                </div>
                                {element.description ? (
                                    <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                ):null}
                            </div>
                        </div>
                    </div>
                )
            default:
                return (
                    <div className='col-lg-12'>
                        <div className='fv-row mb-5 d-flex align-items-start justify-content-between'>
                            <label className='form-label pt-4 mb-0 me-3 w-25'>{element.title.toString().replace('(valeur 1)','').replace('(value 1)','')} {props.element.required ? <span className='red'>*</span> : ""}</label>
	                        <div className="w-100">
                                <Field
                                    type={controlledType}
                                    className='form-control form-control-lg form-control-solid'
                                    name={nameInput}
                                    id={element.id ? element.id.toString() : ""}
                                />
                                <div className='text-danger mt-2'>
                                    <ErrorMessage name={typeof element.name != "undefined" ? element.name.toString() : ""} />
                                </div>
                                {element.description ? (
                                    <div className='form-text' dangerouslySetInnerHTML={{__html: element.description}} />
                                ):null}
                            </div>
	                    </div>
                    </div>
                )
        }
}

export default CustomInput;